import { filterMenu } from "@client/lib/menu";
import { createShallowEqualSelector, getLayoutSettingValueSelector, menuItemsSelector } from "@client/selectors";

const displaySelector = getLayoutSettingValueSelector("display", "sidePanel");

export const enhancedMenuItemsSelector = createShallowEqualSelector(
  [displaySelector, menuItemsSelector],
  (display, menuItems) => {
    return filterMenu(menuItems, {
      currentOnly: display === "only_children_items",
      cutChildren: false,
      pages: undefined,
      level: 0
    });
  }
);
